import { render, staticRenderFns } from "./FinalDocumentEdit.vue?vue&type=template&id=654dd78b&"
import script from "./FinalDocumentEdit.vue?vue&type=script&lang=ts&"
export * from "./FinalDocumentEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports